
if(document.body.classList.contains('holiday-ecards')) {
  console.log("loading ecards")
  require('./styles/ecards.less')
}



// WEBPACK FOOTER //
// ./theme/micro-ecards/index.js